import { AxiosInstance } from 'axios';

import { WEATHER_API_KEY } from '@src/constants/apis';
import { WeatherApiResponse, WeatherState, WeatherType } from '@src/services/weather/types';

const inRange = (id: number, from: number, to: number) => id >= from && id <= to;

export class WeatherService {
  constructor(private networkService: AxiosInstance) {}

  public async getCurrentWeather(city: string, locale: string): Promise<WeatherState | undefined> {
    const isImperial = ['en-US'].includes(locale);

    const params = new URLSearchParams({
      APPID: WEATHER_API_KEY as string,
      type: 'accurate',
      cnt: '17',
      q: city,
      units: isImperial ? 'imperial' : 'metric',
      lang: locale,
    });
    const response = await this.networkService.get<WeatherApiResponse>(`/weather?${params.toString()}`);
    const weather = response.data;

    if (!weather) {
      return undefined;
    }

    const weatherType = WeatherService.resolveWeatherType(weather.weather[0].id);
    const temperatureUnit = isImperial ? 'fahrenheit' : 'celsius';

    return {
      temperature: weather.main.temp,
      temperatureUnit,
      weatherType,
      title: weather.weather[0].main,
      description: weather.weather[0].description,
    };
  }

  static resolveWeatherType(id: number): WeatherType {
    if (inRange(id, 200, 232)) {
      return 'thunder';
    }
    if (inRange(id, 300, 321)) {
      return 'drizzle';
    }
    if (inRange(id, 500, 531)) {
      return 'rain';
    }
    if (inRange(id, 600, 622)) {
      return 'snow';
    }
    if (inRange(id, 801, 804)) {
      return 'clouds';
    }

    return 'clear';
  }
}
